
import {Container, Row, Col } from 'reactstrap';
import "../styles/Libros.css";
import Card from '../components/Card/Card.js';

import  eugenia from "../assets/images/EugeniaRafo.jpeg"
import anajo from "../assets/images/AnaJo.jpeg";
import analia from "../assets/images/Analia.jpeg"
import nora from "../assets/images/Norita.jpeg"
import patricia from "../assets/images/PatoFer.jpeg"
import alejandra from "../assets/images/alejandraG.jpeg"

import backgroundTextura from "../assets/images/textura.jpg"





const Libros = () => {

return (
    <> <div style={{ backgroundImage: `url(${backgroundTextura})` }}>
    <Container>
<Row>
    <Col>
        <h2 className='reseña'>Opinión lector</h2>
        <hr />
    </Col>
</Row></Container>


<Container className="Cards">



<Card
title='Alejandra Gimenez'
imageUrl={alejandra}
body='En este libro, familiar y personal la autora toma los silencios familiares y devela aquello que no fue dicho.
Tucumana, de una voz cálida y amorosa nos lleva de la mano por una serie de relatos que conforman una historia.
Todas las familias guardan secretos. Muchos necesitan saber, otros no.
De rápida lectura, nos permite observar parte de una historia familiar que afecta de diferentes formas a sus integrantes.
Sencilla y profunda en su intimidad.'
/>


<Card
title='Eugenia Rafo'
imageUrl={eugenia}
body='Leí cada una de tus historias, cerraba los ojos y pensaba mucho en mi niñez, recordé a mis abuelos, tíos y la familia esa que contas con defectos y virtudes, con muchos secretos que aún hoy siento que desconozco. Gracias por haberme llevado a mi niñez'
/>


<Card 
title='Ana Jo. Herrera'
imageUrl={anajo}
body='No tengo palabras para decirte lo hermoso que es tu libro, pero más aún lo que representa. Lloro de emoción.'

/>

<Card 
title='Analía Argañaraz'
imageUrl={analia}
body='Historias muy bien contadas, me encantó. Con una pluma impecable pudiste describir una historia familiar que viviste en secreto... somos una generación con muchos secretos. Superviviente de tu historia, mezclada con música y una fuerte presencia paternal.'

/>


<Card 
title='Nora B. Acosta'
imageUrl={nora}
body='Luego de la lluvia, el silencio y tu bello relato expresado con tanto sentimiento, mezclado con lágrimas de alegría.'

/>

<Card 
title='Patricia Fernández'
imageUrl={patricia}
body='Es hermoso. Me hiciste reír porque, en varias partes, me trajiste a la memoria parte de mi vida y, por otra parte, me hiciste llorar por "Marcelito". '

/>


{/*
<Row>
    <Col>
        <img src={reseñador} alt="autora y reseñadora" className='reseñadores' />
    </Col>
</Row>



<div style={{ backgroundColor: "#887e2960" }}><p>El germen de La Hoja Cortada es el silencio y una voluntad de transformarlo en identidad, en palabra que desvanece el karma.
    Una nouvelle íntima y visceral, nacida en tiempos de pandemia, en el viaje hacia los recuerdos de la protagonista.
    Avanza en relatos breves y anecdóticos, que conforman una trama que atraviesa la vida de la protagonista, su desarrollo y su decisión de hacerla palabra.
    Hay silencio en abundancia, temores, mucho dolor, resiliencia, palabra y amor.</p></div>


*/}

</Container>
</div></>
)
}

export default Libros